"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Props = void 0;
var operators_1 = require("rxjs/operators");
var window_1 = require("../../utils/window");
var dom_1 = require("../../utils/dom");
var utils_1 = require("../../utils");
var Props = /** @class */ (function () {
    function Props() {
        this.windowAdapter = new window_1.WindowAdapter();
    }
    Props.prototype.on = function (name) {
        return this.windowAdapter.getProperty().pipe(operators_1.map(function (_a) {
            var props = _a.props;
            return props[name];
        }));
    };
    Props.prototype.find = function (property) {
        var webAdapter = dom_1.atWindow().webAdapter;
        return !utils_1.isNullOrUndefined(webAdapter) ? webAdapter['props'][property] : {};
    };
    return Props;
}());
exports.Props = Props;
